<template> 

    <div class="container-fluid m-0 p-0" id="home" >
        <mg-header></mg-header>

        <slot></slot>
        
        <mg-footer></mg-footer>
    </div>

</template>
 
<script setup>
    // Images

    // Vue imports
    import { ref, reactive, computed, onMounted } from 'vue'
    import { useRouter } from 'vue-router'
    import { useStore } from "vuex"

    // Hooks
    const router = useRouter()
    const store = useStore()

    // Injects

    // Computeds

    // Variables
   

    // Methods

</script>


<style lang="scss">
    //@import 'ASSETS/scss/minxin.scss';
</style>